export async function increaseStakeToTowns(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { depositId, amount, signer } = fnArgs;
    if (!spaceDapp?.townsToken || !spaceDapp.config.addresses.utils.towns) {
        throw new Error('spaceDapp.townsToken is required for increaseStakeToTowns operation.');
    }
    const townsAddress = spaceDapp.config.addresses.utils.towns;
    const rewardsAddress = spaceDapp.config.addresses.baseRegistry;
    const toApproveCallData = spaceDapp.townsToken?.interface.encodeFunctionData('approve', [
        rewardsAddress,
        amount,
    ]);
    const toIncreaseStakeCallData = spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('increaseStake', [
        depositId,
        amount,
    ]);
    return smartAccount.sendUserOp({
        toAddress: [townsAddress, rewardsAddress],
        callData: [toApproveCallData, toIncreaseStakeCallData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
